<script>
import {mapActions, mapState} from "pinia";
import {authStore} from "@/store/authStore";
import Dialog from "primevue/dialog";

export default {
  name: "SuccessfulSignUpModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(authStore, [
      'successfulSignUpModalState',
      'userInfo'
    ]),
    modalState: {
      get() {
        return this.successfulSignUpModalState;
      },
      set() {
        this.closeModal();
      },
    },
  },
  methods: {
    ...mapActions(authStore, [
        'openSuccessfulSignUpModal',
        'closeSuccessfulSignUpModal',
        'checkUserIsApproved',
        'toggleCreateOrgModal'
    ]),
    openProfile() {
      this.$router.push({ name: 'UserView', params: { id: this.userInfo.id }});
      this.closeSuccessfulSignUpModal();
    },
    registerOrganization() {
      if (this.checkUserIsApproved()) {
        this.toggleCreateOrgModal();
        this.closeSuccessfulSignUpModal();
      }
    },
    closeModal() {
      this.closeSuccessfulSignUpModal();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          modal
          :header="$t('auth.successfullyCreated.t1')"
          class="successful-sign-up-modal"
  >
    <div>
      <p>{{$t('auth.successfullyCreated.p1')}}</p>
      <p>{{$t('auth.successfullyCreated.p2')}}</p>
      <p>{{$t('auth.successfullyCreated.p3')}}</p>
      <ul>
        <li>
          {{$t('auth.successfullyCreated.list.item1.p1')}}
          <span class="text-link font-weight-bold" @click="openProfile()">
            {{$t('auth.successfullyCreated.list.item1.l1')}}
          </span>
          {{$t('auth.successfullyCreated.list.item1.p2')}}
        </li>
        <li>
          {{$t('auth.successfullyCreated.list.item2.p1')}}
          <span class="text-link font-weight-bold" @click="registerOrganization()">
            {{$t('auth.successfullyCreated.list.item2.l1')}}
          </span>
          {{$t('auth.successfullyCreated.list.item2.p2')}}
        </li>
        <li>
          {{$t('auth.successfullyCreated.list.item3.p1')}}
          <span class="text-link font-weight-bold" @click="closeModal()">
            {{$t('auth.successfullyCreated.list.item3.l1')}}
          </span>
          {{$t('auth.successfullyCreated.list.item3.p2')}}
        </li>
      </ul>
      <p>{{$t('auth.successfullyCreated.p3')}}</p>
      <p><span class="text-italic">{{$t('auth.successfullyCreated.p4')}}</span> &#128578;</p>
      <p>{{$t('auth.successfullyCreated.p5')}}</p>
    </div>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeModal()">
        {{$t('common.buttons.close')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.successful-sign-up-modal {
  max-width: 500px;
  .p-dialog-content {
    padding: 20px;
    font: 14px/18px "Open Sans", Arial, sans-serif !important;

    ul {
      padding-left: 20px;
      list-style: disc;
      li {
        margin-bottom: 5px;
      }
    }

    p, ul,  {
      margin-bottom: 10px;
    }

    .text-link {
      font-weight: 600;
      cursor: pointer;
    }
  }
}

</style>